"use client";

import React from "react";
import GenericSubstantiveProcedures from "../../substantive-procedures/GenericSubstantiveProcedures";

interface TrdRcvSubstantiveProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Trade Receivables";

export default function TrdRcvSubstantive({ onBack, setActiveSection }: TrdRcvSubstantiveProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
